import Component from './orders'

export default Component